import {
	ModelReadAsMaster,
	ModelReadMyAsset, 
	ModelReadBookedAsset, 
	ModelReadIncomingMessage,
	ModelRegisterReasign,
  	BulkModelRegisterReasign,
	ModelConfirmationAnswer,
	ModelCancelReasign,
	ModelCancelBooking,
	ModelReadMasterReservation,
	ModelMoveAsset,
  	ModelReadSummary,
  	ModelExtendDueDate,
  	ModelUpdateReschedule,
  	ModelRequestMaintenance,
  	ModelReadReservationCheck,
  	ModelReadMyAssetSummary,
  	ModelReadAllAsset,
  	ModelRegisterQRReassign,
  	ModelReadQRReassign,
  	ModelQRConfirmationAnswer
} from './model.js'
// import {RequestinProcess} from '../helper/request.action.js'


// READ
export function PresenterReadAsMaster(params) {
	if(params.action === 'USER'){
		params.data.query = 'User/Master/';
	} else if(params.action === 'SITE') {
		params.data.query = 'Location/Sites-Master/';
	} else if(params.action === 'MAINTENANCE') {
    params.data.query = 'Maintenance/Service/Master/';
  } else {
		params.data.query = 'Location/Master/';
	}
	ModelReadAsMaster(params)
}

export function PresenterReadMyAsset(params) {
	// if(params.action === 'Next') {
	// 	params.data.url = params.self.state.next;
	// }
	ModelReadMyAsset(params)
}

export function PresenterReadBookedAsset(params) {
	ModelReadBookedAsset(params)
}

export function PresenterReadAllAsset(params) {
	ModelReadAllAsset(params)
}

export function PresenterReadIncomingMessage(params) {
	if(params.action === 'Next') {
		params.data.url = params.self.state.NextPage; 
	}else{
		params.data.url = null;
	}
	ModelReadIncomingMessage(params)
}

export function PresenterReadMyAssetSummary(params) {
  if(params.self.props.tenant) {
    params.data.url = 'Asset/Summary/Tenant/'
  } else {
    params.data.url = 'Asset/Summary/'
  }
	ModelReadMyAssetSummary(params)
}

export function PresenterReadMasterReservation(params) {
	ModelReadMasterReservation(params)
}

export function PresenterReadReservationCheck(params) {
	ModelReadReservationCheck(params)
}

export function PresenterReadQRReassign(params) {
	ModelReadQRReassign(params)
}

// REGISTER
export function PresenterRegisterReasign(params) {
	ModelRegisterReasign(params)
}

export function BulkPresenterRegisterReasign(params) {
	BulkModelRegisterReasign(params)
}

export function PresenterConfirmationAnswer(params) {
	ModelConfirmationAnswer(params)
}

export function PresenterRegisterRequestMaintenance(params) {
	ModelRequestMaintenance(params)
}

export function PresenterQRConfirmationAnswer(params) {
  ModelQRConfirmationAnswer(params)
}

// UPDATE
export function PresenterCancelReasign(params) {
	ModelCancelReasign(params)
}

export function PresenterCancelBooking(params) {
	ModelCancelBooking(params)
}

export function PresenterUpdateReschedule(params) {
	ModelUpdateReschedule(params)
}

export function PresenterMoveAsset(params) {
	ModelMoveAsset(params)
}

export function PresenterReadSummary(params) {
  ModelReadSummary(params)
}

export function PresenterExtendDueDate(params) {
  ModelExtendDueDate(params)
}

export function PresenterRegisterQRReasign(params) {
	ModelRegisterQRReassign(params)
}


// WEBPACK FOOTER //
// ./src/App/home/presenter.js